module.exports = __webpack_public_path__ + "static/media/excelSecond.b2070cc1.webp";